;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();export const COIN_NAME_TO_COINCAP_API_COIN_NAME_MAP: Record<string, string> = {
  ripple: 'xrp',
};

export const CRYPTO_CHANGES_KEY = 'crypto-changes';
